import { render, staticRenderFns } from "./alterForm.vue?vue&type=template&id=7bf9d921&"
import script from "./alterForm.vue?vue&type=script&lang=js&"
export * from "./alterForm.vue?vue&type=script&lang=js&"
import style0 from "./alterForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports